module.exports = __webpack_public_path__ + "img/chauffage.f20082b4.png";